import { render, staticRenderFns } from "./OtherInfo.vue?vue&type=template&id=34eca1c4"
import script from "./OtherInfo.vue?vue&type=script&lang=js"
export * from "./OtherInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports